module.exports = __webpack_public_path__ + "static/img/logo7.05e9192.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutions/logo7.png
// module id = MA4p
// module chunks = 0